module.exports = __webpack_public_path__ + "img/fle.3d226d9d.png";